import * as actionTypes from './types';

function setCarrierContactContent(state, action) {
    return {
        ...state,
        [action.meta]: action.payload,
    };
}

const reducerFunctions = {
    [actionTypes.SET_CARRIER_CONTACT_CONTENT]: setCarrierContactContent,
};

export default function reducer(state = {}, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}
